/* Ella Stína: myndbönd í röðinni spila fyrstu sekúndurnar í lykkju, valmynd lokast við smell og flokkahnappar sía vörur */
(function () {
  function initReels(root) {
    var vids = (root || document).querySelectorAll('.es-reel video');
    vids.forEach(function (v) {
      if (v.dataset.esInit) return;
      v.dataset.esInit = '1';
      var reel = v.closest('.es-reel');
      var clip = parseFloat((reel && reel.dataset.clip) || '5');
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.addEventListener('timeupdate', function () { if (v.currentTime >= clip) { v.currentTime = 0; } });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
        }, { rootMargin: '200px' }).observe(v);
      } else { v.play(); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initReels(document); });
  document.addEventListener('shopify:section:load', function (e) { initReels(e.target); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.es-header__drawer a');
    if (a) { var d = a.closest('details'); if (d) d.removeAttribute('open'); }
  });
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.es-chip[data-es-tab]');
    if (!chip || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var wrap = chip.closest('.es-products') || document;
    var panel = wrap.querySelector('[data-es-panel="' + chip.getAttribute('data-es-tab') + '"]');
    if (!panel) return;
    e.preventDefault();
    wrap.querySelectorAll('.es-chip[data-es-tab]').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-current', on ? 'true' : 'false');
    });
    wrap.querySelectorAll('[data-es-panel]').forEach(function (p) { p.hidden = p !== panel; });
  });
})();
